import React from 'react';

import { Button, Flexbox, Icon, Typography } from '@hiiretail/synergy-ui';

import {
  RetryButtonContainer,
  StyledErrorIconContainer,
  StyledRefreshedIcon,
  StyledRetry,
  StyledTypographyContainer,
} from './Retry.styles';

type RetryProps = {
  text: string;
  message?: string;
  handleClick?: () => void;
  size?: 'sm' | 'lg' | 'xlg';
  justifyContent?: 'space-between' | 'center';
};

type RetryComponent = React.FC<RetryProps>;

/**
 * @param text will be passed after 'An error occurred while loading...'
 * @param message
 * @param handleClick triggers on Retry button click
 * @param size sets paddings, margins and proportions
 * @param justifyContent sets justifyContent property to the wrapper
 * @constructor
 */
export const Retry: RetryComponent = ({
  text,
  message,
  handleClick,
  size = 'lg',
  justifyContent = 'space-between',
}) => {
  return (
    <StyledRetry
      container
      item
      flex="1 1 auto"
      direction="column"
      alignItems="center"
      justifyContent={justifyContent}
      size={size}
    >
      <StyledErrorIconContainer size={size}>
        <Icon.WarningRound color={() => '#F44336'} size="lg" />
      </StyledErrorIconContainer>

      <StyledTypographyContainer container direction="column" alignItems="center" size={size}>
        <Typography variant="header3" textAlign="center">
          Ooops!
        </Typography>
        <Typography textAlign="center">
          {message ? message : `An error occurred while loading ${text}, click the button to retry`}
        </Typography>
      </StyledTypographyContainer>

      {handleClick && (
        <RetryButtonContainer container justifyContent="center">
          <Button
            data-testid="retryButton"
            fullWidth={size === 'lg'}
            onClick={() => {
              handleClick();
            }}
          >
            <Flexbox container gutter={1} alignItems="center">
              <Flexbox item>
                <Typography color={() => 'white'}>Retry</Typography>
              </Flexbox>
              <Flexbox item container alignItems="center">
                <StyledRefreshedIcon color={() => 'white'} />
              </Flexbox>
            </Flexbox>
          </Button>
        </RetryButtonContainer>
      )}
    </StyledRetry>
  );
};
